import { createSlice } from '@reduxjs/toolkit';
import Api from "services/api";

const initialState = {
  data: [],
  total: 0,
  last_page: 1,
  current_page: 1,
  per_page: 20,
  loader: false,
  error: null,
};

const declinedAppointmentsSlice = createSlice({
  name: 'declinedAppointments',
  initialState,
  reducers: {
    setDeclinedAppointments: (state, { payload }) => {
      state.data = payload?.data ?? [];
      state.total = payload?.total ?? 0;
      state.last_page = payload?.last_page ?? 1;
      state.current_page = payload?.current_page ?? 1;
      state.per_page = payload?.per_page ?? 20;
    },
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
  },
});

export const fetchDeclinedAppointments = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true));
  try {
    const result = await Api.fetchInterpreterDeclinedAppointments(page, params);
    if (result?.status >= 200 && result?.status < 300) {
      dispatch(setDeclinedAppointments(result.data.data));
    } else {
      dispatch(setError(result?.data));
    }
  } catch (error) {
    dispatch(setError({ message: 'Something went wrong' }));
  }
  !disableLoader && dispatch(setLoader(false));
};

export const { setDeclinedAppointments, setLoader, setError } = declinedAppointmentsSlice.actions;

export default declinedAppointmentsSlice.reducer;

export const DeclinedAppointmentsSelector = (state) => state.declinedAppointments;
